import React from "react";
import { BiSolidStar } from "react-icons/bi";

const StarRating = ({ onClick, filledStars = 0 }) => {
  const handleStarClick = (value) => {
    if (onClick) {
      onClick(value);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex space-x-1">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          return (
            <button
              key={index}
              onClick={() => handleStarClick(starValue)}
              className="cursor-pointer transition-all"
              // title={`Rate ${starValue}`}
            >
              <BiSolidStar
                size={22}
                color={starValue <= filledStars ? "#f1c40f" : "#d1d7dc"}
              />
            </button>
          );
        })}
        <div className="text-xs font-semibold text-white mt-1">
          {filledStars > 0 ? "Edit Rating" : "Your Rating"}
        </div>
      </div>
    </div>
  );
};

export default StarRating;
